module.exports = "/2/2-if-statements/index.html.58e985aebd494c11dc0d189c7f303f03.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30008.md
 ** module id = 541
 ** module chunks = 0
 **/